import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { AppSidebar } from './AppSidebar'
import { AppHeader } from './AppHeader'
import { readSidebarNavMode, useSidebarNavMode } from '../../hooksCompartilhados/useSidebarNavMode'
import {
  useSomenteRailSubmenuPreferencia,
  useSomenteRailSubmenuDesktopAtivo,
} from '../../hooksCompartilhados/useSidebarSomenteRailSubmenu'

export function AppLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const [navMode, setNavMode] = useSidebarNavMode()
  const [somenteRailSubmenu, setSomenteRailSubmenu] = useSomenteRailSubmenuPreferencia()
  const railAtivoDesktop = useSomenteRailSubmenuDesktopAtivo(somenteRailSubmenu)

  /** Sincronizado com a largura real da sidebar (`AppSidebar` usa `layoutEffect`): rail `w-72` ou menu expandido = `lg:ml-72`; só ícones sem rail = `lg:ml-[4.5rem]`. */
  const [marginLg, setMarginLg] = useState(() =>
    readSidebarNavMode() === 'icons' ? 'lg:ml-[4.5rem]' : 'lg:ml-72')

  return (
    <div className="flex h-[100dvh] min-h-[100dvh] overflow-hidden bg-gray-50">
      <AppSidebar
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
        navMode={navMode}
        onNavModeChange={setNavMode}
        somenteRailSubmenu={somenteRailSubmenu}
        onSomenteRailSubmenuChange={setSomenteRailSubmenu}
        railAtivoDesktop={railAtivoDesktop}
        onLgMainMarginClass={setMarginLg}
      />

      {isSidebarOpen && (
        <button
          type="button"
          aria-label="Fechar menu lateral"
          className="fixed inset-0 z-40 bg-black/40 lg:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      <div
        className={`flex min-w-0 flex-1 flex-col transition-[margin] duration-300 ease-out ${marginLg}`}
      >
        <header className="shrink-0">
          <AppHeader onOpenSidebar={() => setIsSidebarOpen(true)} />
        </header>

        <main className="min-h-0 flex-1 overflow-auto">
          <div className="mx-auto w-full max-w-full p-4 md:p-6 2xl:p-10">
            <div className="space-y-6">
              <Outlet />
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}
